<template>
    <div id="creditohabitacao">
        <div id="header" style="background-image:url('/static/images/pedido-ch/ImagemTopo.png')">
            <div class="container">
                <div class="img-container">
                    <img src="/static/images/layout/LogoBranco.png">
                </div>
                <h2>PEÇA O SEU</h2>
                <h1>CRÉDITO HABITAÇÃO</h1>
            </div>
        </div>
        <div class="container">

            <p v-if="step === 1">
                Crédito Habitação moroso e complicado? Agora não!<br>
                &nbsp;<br>
                A nossa plataforma dá-lhe  o que precisa para dar o próximo passo no seu Crédito Habitação.
                Sem sair de casa ou dirigir-se inicialmente a uma agência bancária poderá saber se o seu pedido
                tem viabilidade e quais as melhores condições propostas para o seu caso. Connosco este processo torna-se <span style="font-weight:900;">facílimo</span>.
            </p>

            <app-wizard :colors="colors" @goStep="goStep($event)"></app-wizard>

            <transition>
                <component ref="child" :submitted="submitted" :stepdata='stepdata' :steps='steps' :is="'step' + step" transition="fade" transition-mode="out-in"></component>
            </transition>

            <div id="buttons">
                <a class="button is-light mr20" style="border: solid 1px #969696;" @click="goStep(step+1)">&nbsp;VOLTAR&nbsp;</a>
                <a class="button is-primary ml20" @click="goStep(step+1)">SEGUINTE</a>
            </div>

        </div>
        <app-modal-message :message-modal="messageModal" @closeMessage="messageModal = null; $router.push({name: 'home'})"></app-modal-message>

        <app-footer-fake></app-footer-fake>
    </div>
</template>
<script>
import AppWizard from "../components/Wizard";
import AppFooterFake from "../components/FooterFake";
import Step1 from "./CreditoHabitacao/Step1";
import Step2 from "./CreditoHabitacao/Step2";
import Step3 from "./CreditoHabitacao/Step3";
import Step4 from "./CreditoHabitacao/Step4";
import Step5 from "./CreditoHabitacao/Step5";
import Step6 from "./CreditoHabitacao/Step6";
import AppModalMessage from "../components/ModalMessage";
import {apiUrl} from "../vars";
import {scrollTop} from "../plugins/scrollTopMixin";

export default {
  components: {
    AppWizard,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    AppFooterFake,
    AppModalMessage
  },
mixins: [scrollTop],
  data() {
    return {
      colors: [
        "#d2d2d3",
        "#d2d2d3",
        "#d2d2d3",
        "#d2d2d3",
        "#d2d2d3",
        "#d2d2d3"
      ],

      step: 1,
      nextStep: 1,

      steps: [],

      stepdata: {},

      submitted: false,

      messageModal: null
    };
  },

  watch: {
    step: {
      handler: "stepWatcher",
      immediate: true
    }
  },

  methods: {
    goStep(step) {
      console.log("go", step);
      // If you are not allowed to go to the selected step
      if (step > this.nextStep + 1) {
        console.log("case 1", step);

        return;
      }

      // If you are trying to go to the next step for the first time
      if (step === this.step + 1 && this.step === this.nextStep) {
        // But you haven't filled all fields
        this.submitted = true;
        console.log("case 2", step);

        if (this.$refs.child.missingField && (step !== 4 || step !== 5)) {
          console.log("missing", step);
          return;
        } else {
          console.log("good", step);

          // Unlocks the next step
          this.submitted = false;
          this.$set(this.steps, this.step, this.stepdata);
          this.nextStep = step;
          switch (step) {
            case 1:
              this.step = 1;
              break;
            case 2:
              this.step = 2;
              this.stepdata = {
                proponente_1: {},
                proponente_2: {},
                fiador_1: {},
                fiador_2: {}
              };
              break;
            case 3:
              this.step = 3;
              this.stepdata = {
                proponente_1: {},
                proponente_2: {},
                fiador_1: {},
                fiador_2: {}
              };
              break;
            case 4:
              this.step = 4;
              this.stepdata = {
                patrimonio: {
                  imovel: "",
                  utilizacao: "",
                  valor: 0,
                  vende: ""
                },
                patrimonios: []
              };
              break;
            case 5:
              this.step = 5;
              this.stepdata = {
                encargo: {
                  tipo: "",
                  valor_mensal: 0,
                  saldo_divida: 0,
                  quer_liquidar: ""
                },
                encargos: [],
                pensao_alimentos: 0
              };
              break;
            case 6:
              this.step = 6;
              this.stepdata = {
                info: ""
              };
              break;
            case 7:
            	console.log(this.steps)
                let str_steps = JSON.stringify(this.steps)
                axios.post(`${apiUrl}/api/pedido-ch`, {blob: str_steps}).then(r=>{
                	console.log(r)
                })
              this.messageModal =
                "O seu pedido foi submetido com sucesso para análise. Irá receber brevemente a resposta à sua solicitação. Até breve.";
              break;
          }
        }
      } else {
        // Populate the fields of an already visited page
        this.stepdata = this.steps[step];
      }

      let el = document.getElementById("steps-progress");
      this.$SmoothScroll(el);
    },

    stepWatcher() {
      for (let i = 0; i < this.colors.length; i++) {
        if (i < this.nextStep) {
          this.$set(this.colors, i, "#2d3256");
        } else {
          this.$set(this.colors, i, "#d2d2d3");
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#creditohabitacao {
  background-color: #f5f5f5;
}

#header {
  min-height: 33.6vw;
  position: relative;
  line-height: 1;
  background-size: cover;
  background-position: center;
}

p {
  text-align: justify;
  font-weight: 500;
  max-width: 45rem;
  margin: auto;
}

#header h2 {
  font-weight: 300;
  font-size: 3rem;
  color: white;
}
#header h1 {
  font-weight: 600;
  font-size: 4.5rem;
  color: white;
}
#header img {
}

.img-container {
  margin-top: 4vw;
  width: 270px;
  height: 60px;
  margin-bottom: 4vw;
}

.img-container img {
  width: 100%;
  height: auto;
}

#buttons {
  padding: 3rem 6rem 6rem;
  display: flex;
  justify-content: center;
}

#buttons a {
  padding: 1.5rem 3rem;
}

@media screen and (max-width: 768px) {
  .img-container {
    margin-bottom: 2vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/CreditoHabitacao.vue